<script lang="ts">
import type { HeaderBanner } from '@/components/banners/header/HeaderBannerBaseCard.vue'
import HeaderBannerCard from '@/components/banners/header/HeaderBannerCard.vue'
import AppCarousel from '@/components/carousel/AppCarousel.vue'
import CarouselItem from '@/components/carousel/CarouselItem.vue'
import { usePromotions } from '@/composables/usePromotions'
import { defineComponent, onMounted } from 'vue'

import DepositBanner from '../../banners/items/DepositBanner.vue'

export default defineComponent({
  components: {
    AppCarousel,
    CarouselItem,
    DepositBanner,
    HeaderBannerCard,
  },
  props: {
    title: {
      type: String,
    },
  },
  setup() {
    const { loadPromotions, showWelcomeBanner } = usePromotions()

    onMounted(() => {
      void loadPromotions()
    })

    return {
      showWelcomeBanner,
    }
  },
  data() {
    return {
      bannerMembership: {
        variant: 'clipped',
        text: 'Unlock Prizes Every Day!',
        subtext: 'Members get entries for 30+ prize draws every month!',
        cta_text: '7 Day Free Trial',
        show_trustpilot: true,
        squiggle_color: 'purple',
        route: {
          name: 'memberships',
        },
        image_url: '/assets/images/banners/champagne.png',
      } as HeaderBanner,
      bannerMemberPrizes: {
        variant: 'image',
        badge_text: "You're Entered!",
        text: '30+ Exclusive Prize Draws This Month',
        cta_text: 'View Prizes',
        show_trustpilot: true,
        show_logo: false,
        squiggle_color: 'purple',
        route: {
          name: 'prizes',
          query: { switch: 'featured-prizes' },
        },
        image_url: '/assets/images/banners/membership.webp',
      } as HeaderBanner,
      bannerTurbo: {
        variant: 'clipped',
        text: 'Rip The Pack. <br>Reveal the <br>Win.',
        // subtext: '',
        cta_text: `Play For ${this.$n(0.97, 'currency')}`,
        show_trustpilot: true,
        show_logo: false,
        squiggle_color: 'purple',
        route: {
          name: 'instant-win',
          params: { instantWinCode: 'turbo-pack' },
        },
        image_url: '/assets/images/banners/turbo-pack-1_1.webp',
      } as HeaderBanner,
      bannerAudi: {
        variant: 'image',
        text: 'Win This Audi RS6 For Free!',
        // subtext: 'Your next win could be today!',
        cta_text: 'Free Entry',
        show_trustpilot: true,
        show_logo: true,
        squiggle_color: 'purple',
        route: {
          name: 'campaign',
          params: { campaignCode: 'win-an-audi-rs6-mar31-ref' },
        },
        image_url: '/assets/images/banners/audi-rs6-green.webp',
      } as HeaderBanner,
      bannerDailySpin: {
        variant: 'clipped',
        text: 'Want Free Credit?',
        subtext: 'Try our daily game now!',
        cta_text: 'Play For Free',
        show_trustpilot: true,
        show_logo: false,
        squiggle_color: 'purple',
        route: {
          name: 'daily-spins',
        },
        image_url: '/assets/images/banners/vertical-icons-large-cut.webp',
      } as HeaderBanner,
    }
  },
})
</script>

<template>
  <AppBanner
    aria-labelledby="banner-section-label"
    class="banner-section-banner !pt-0 @sm/main:!pt-10"
  >
    <span id="banner-section-label" class="sr-only">
      Check out our latest campaigns and instant prize games!
    </span>

    <AppCarousel
      :title
      :autoplay="false"
      :show-navigation="false"
      framed
      frame-class="my-0 !p-0 bg-transparent border-0"
      container-class="!gap-0 md:gap-3"
    >
      <CarouselItem
        v-if="$userStore.isLoggedOut"
        class="w-full @sm/main:w-1/2 @lg/main:w-1/3"
      >
        <HeaderBannerCard :banner="bannerAudi" />
      </CarouselItem>

      <CarouselItem
        v-if="$userStore.isLoggedIn && !$userStore.hasSubscription"
        class="w-full @sm/main:w-1/2 @lg/main:w-1/3"
      >
        <HeaderBannerCard :banner="bannerMembership" />
      </CarouselItem>

      <CarouselItem
        v-if="$userStore.isLoggedIn && $userStore.hasSubscription"
        class="w-full @sm/main:w-1/2 @lg/main:w-1/3"
      >
        <HeaderBannerCard :banner="bannerMemberPrizes" />
      </CarouselItem>

      <CarouselItem
        v-if="$userStore.isLoggedIn && showWelcomeBanner"
        class="w-full @sm/main:w-1/2 @lg/main:w-1/3"
      >
        <DepositBanner />
      </CarouselItem>

      <CarouselItem class="w-full @sm/main:w-1/2 @lg/main:w-1/3">
        <HeaderBannerCard :banner="bannerTurbo" />
      </CarouselItem>

      <CarouselItem
        v-if="$userStore.isLoggedOut"
        class="w-full @sm/main:w-1/2 @lg/main:w-1/3"
      >
        <HeaderBannerCard :banner="bannerMembership" />
      </CarouselItem>

      <CarouselItem
        v-if="$userStore.isLoggedIn"
        class="w-full @sm/main:w-1/2 @lg/main:w-1/3"
      >
        <HeaderBannerCard :banner="bannerDailySpin" />
      </CarouselItem>
    </AppCarousel>
  </AppBanner>
</template>

<style lang="scss" scoped>
.banner-section-banner {
  @apply pb-0 px-0 @md/main:px-8;

  &:deep(.carousel-header) {
    @apply px-3 @md/main:px-0;
  }
}
</style>
